import { useRouter } from "next/router";
import {
  PremiumDetailHeading,
  PremiumDetailItem,
  PremiumDetailType,
  PremiumDetailsContainer,
  PremiumDetailValue,
  PremiumdetailWrapper,
  GrossPremiumAmount,
  GrossPremiumCueText,
  GrossPremiumText,
  StyledBox
} from "./styles";
import { Flex, Box } from "@acko-tech/building-blocks.ui.common";
import { isEmpty } from "@utils/lodash";
import { PREMIUM_DETAILS } from "@utils/index";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const PremiumDetails = ({ children, containerStyles, grossPremiumContainerStyles, ...props }) => {
  const {
    premiumDetails,
    actions,
    applyMarginAdjustment,
    mStyles
  } = props || {};
  const { on_load } = actions || {};

  const renderPremiumItem = (item) => {
    if (!item || item?.length === 0) return null;
    return item?.map((premiumItem) => {
      return (
        <PremiumDetailItem>
          <>
            <PremiumDetailType>{premiumItem?.key}</PremiumDetailType>
            <PremiumDetailValue isDiscount={premiumItem?.isDiscount}>
              {premiumItem?.isDiscount
                ? `- ₹${premiumItem?.value}`
                : `₹${premiumItem?.value}`}
            </PremiumDetailValue>
          </>
        </PremiumDetailItem>
      );
    });
  };

  const getPremiumDetailsJsx = (premiumDetailItem) => {
    if (!premiumDetailItem || isEmpty(premiumDetailItem?.data)) return null;
    return (
      <PremiumdetailWrapper>
        {premiumDetailItem?.heading && (
          <PremiumDetailHeading>
            {premiumDetailItem?.heading}
          </PremiumDetailHeading>
        )}
        {renderPremiumItem(premiumDetailItem?.data)}
      </PremiumdetailWrapper>
    );
  };

  const getGrossPremiumDetailsJsx = (grossPremiumItem) => {
    if (!grossPremiumItem?.data) return null;
    return (
      <PremiumdetailWrapper>
        {grossPremiumItem?.data?.map((item) => {
          return (
            <PremiumDetailItem>
              <Flex
                flexDirection="row"
                styles={{ alignItems: "baseline", gap: "4px", width: "50%" }}
              >
                <GrossPremiumText>{item?.key}</GrossPremiumText>
                <GrossPremiumCueText>{item?.cueText}</GrossPremiumCueText>
              </Flex>
              <GrossPremiumAmount style={grossPremiumContainerStyles}>₹{item?.value}</GrossPremiumAmount>
            </PremiumDetailItem>
          );
        })}
      </PremiumdetailWrapper>
    );
  };

  const GetJsxForType = ({ type, item }) => {
    switch (type) {
      case PREMIUM_DETAILS:
        if (isEmpty(item?.data)) return <></>;
        return (
          <PremiumDetailsContainer 
            style={containerStyles}
            applyMarginAdjustment={applyMarginAdjustment}
          >
            {getPremiumDetailsJsx(item)}
          </PremiumDetailsContainer>
        );
      case "GROSS_PREMIUM":
        return (
          <PremiumDetailsContainer 
            applyMarginAdjustment={applyMarginAdjustment}
          >
            {getGrossPremiumDetailsJsx(item)}
          </PremiumDetailsContainer>
        );
      default:
        return <></>;
    }
  };

  const RenderPremiumDetails = ({ premiumDetails }) => {
    if (!premiumDetails) return null;
    return premiumDetails?.map((detailItem) => {
      return <GetJsxForType type={detailItem?.type} item={detailItem} />;
    });
  };

  return (
    <StyledBox mStyles={mStyles}>
        <RenderPremiumDetails premiumDetails={premiumDetails} />
    </StyledBox>
  );
};

export default connect(mapStateToProps)(PremiumDetails);
